import { createContext } from 'react';
import service from '../../service/authorization';
import { LoginContextProps } from './types';

const { impl: { basic } } = service;

const LoginProvider = createContext<LoginContextProps>({ service: basic, setLoading: () => {} });
LoginProvider.displayName = 'LoginContext';

export default LoginProvider;